<template>
    <div id="main">
        <div class="page">
            <div class="tipos-servicos vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">{{ $t("tipo-veiculo") }}</h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t("despesas") }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{ $t("tipo-veiculo") }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            v-if="permissao.create"
                            class="save-btn"
                            type="button"
                            tag="button"
                            @click="$router.push({ name: 'des-tipo-veiculo-new' })"
                        >
                            {{ $t("adicionar") }}
                        </button>
                    </div>
                </div>

                <div class="search-and-filter">
                    <div class="search-bar">
                        <search-bar
                            :onSearch="debouncedOnSearch"
                        />
                    </div>

                    <div class="situacao-select">
                        <label v-text="$t('situacao')" />
                        <v-select
                            ref="situacaoInput"
                            class="is-100"
                            label="label"
                            :options="situacoes"
                            @input="onSituacaoChanged"
                            v-model="situacao"
                        >
                            <template slot="option" slot-scope="option">
                                {{ $t(option.label) }}
                            </template>
                            <template slot="selected-option" slot-scope="option">
                                {{ $t(option.label) }}
                            </template>
                            <template slot="no-options">{{
                                $t("sem-resultados")
                            }}</template>
                        </v-select>
                    </div>
                </div>

                <div class="registry-wrapper">
                    <container-loader v-if="isLoading && !$store.getters.isLoading" />
                    <empty-table-message v-if="isEmpty" />
                    <b-table
                        v-else
                        :data="motivosDespesas"
                        class="data-table"
                        @sort="sortTable"
                        backend-sorting
                    >
                        <b-table-column
                            v-for="(f, i) in fields"
                            :key="i"
                            :field="f.key"
                            :label="f.key != 'excluir' ? $t(f.key) : ''"
                            :width="f.width"
                            :class="{
                                'excluir-field': f.key == 'excluir',
                                'label-km': f.key == 'label',
                            }"
                            :sortable="f.sortable"
                            :custom-sort="f.sortFn"
                            v-slot="props"
                        >
                            <div v-if="f.key == 'icone'">
                                <span
                                    v-if="!cleanHide"
                                    v-html="buildIcon(props.row[f.key])"
                                    ref="tipoVeiculoIcon"
                                    class="icon has-text-dark"
                                >
                                </span>
                                <!--gerando html com v-html par icones dinamicos -->
                            </div>
                            <div v-else-if="f.key == 'cor'">
                                <div
                                    class="color-block"
                                    :style="{ 'background-color': props.row[f.key] }"
                                ></div>
                            </div>

                            <div v-else-if="f.key == 'descricao'">
                                <router-link
                                    :to="{
                                        name: 'des-tipo-veiculo-edit',
                                        params: { id: props.row.id },
                                    }"
                                >
                                    <pre>{{ props.row[f.key] }}</pre>
                                </router-link>
                            </div>

                            <div v-else-if="f.key == 'situacao'">
                                <b-tag
                                    class="table-tag"
                                    :type="props.row[f.key]==0?'is-danger':'is-success'"
                                    size="is-medium"
                                >
                                    {{ $t(props.row[f.key]==0?"inativo":"ativo") }}
                                </b-tag>
                            </div>
                            <div v-else-if="f.key == 'excluir'">
                                <b-button
                                    v-if="permissao.delete"
                                    class="action-button"
                                    :type="props.row['situacao']==1?'is-danger':'is-success'"
                                    :icon-right="props.row['situacao']==1?'delete':'check'"
                                    @click="chamaChangeSituacao(props.row)"
                                    v-tippy 
                                    :title="$t(props.row['situacao']==1?'desativar':'reativar')"
                                />
                            </div>

                            <div v-else>
                                {{ props.row[f.key] }}
                            </div>
                        </b-table-column>
                    </b-table>
                    <PaginationViewer
                        class="mb-0"
                        :resetPagination="pagination.resetPagination"
                        :totalItems="pagination.totalRows"
                        :perPageOptions="pagination.perPageOptions"
                        :optionStarted="pagination.optionStarted"
                        @change="updatePagination"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ContainerLoader from "@/components/content/loader/ContainerLoader";
import TipoVeiculoService from "@/services/despesas/TipoVeiculoService";
import ValoresKmService from "@/services/despesas/ValoresKmService";

export default {
    components: {
        ContainerLoader,
    },
    data() {
        return {
            cleanHide: false,
            motivosDespesas: [],
            situacoes: [
                { id: 2, label: "todos" },
                { id: 1, label: "ativos" },
                { id: 0, label: "inativos" },
            ],
            situacao: { id: 2, label: "todos" },
            service: new TipoVeiculoService(this.$http, this.$router),
            serviceValoresKm: new ValoresKmService(this.$http, this.$router),
            fields: [
                { key: "icone", width: 70, sortable: false, sortFn: null },
                { key: "cor", width: 70, sortable: false, sortFn: null },
                { key: "descricao", width: null, sortable: true, sortFn: null },
                { key: "situacao", width: 100, sortable: false, sortFn: null },
                { key: 'excluir', width: 20, sortable: false, sortFn: null}
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            delete: null,
            queryFilter: "",
            column: "descricao",
            order: "asc",
            permissao: {},
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[
            this.pagination.optionStarted
        ];
        this.permissao = this.hasPermissionAccess(
            "despesas",
            "cadastros",
            "tipo-veiculo"
        );
        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "tipo-veiculo" },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
        }
    },
    methods: {
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        onSituacaoChanged(val) {
            this.situacao = val ? this.situacoes.filter(v => v.id == val.id)[0] : this.situacoes[0];
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        carregarDados(currentPage = 1) {
            this.cleanHide = true;
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.service
                .findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacao.id,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then(value => {
                    this.motivosDespesas = value;
                    this.isEmpty = this.motivosDespesas.length <= 0;
                })
                .catch(e => {
                    this.isEmpty = true;
                    this.$root.showMessage("error", "msg-erro-load");
                    console.error("Erro ao carregar os acertos.");
                })
                .finally(_ => {
                    this.isLoading = false;
                    this.cleanHide = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            let list = body.content.map(m => {
                return {
                    id: m.idtipoveiculo,
                    descricao: m.descricao,
                    cor: m.cor,
                    icone: m.icone.toLowerCase(),
                    situacao: m.situacao,
                    excluir: "excluir",
                };
            });
            return list;
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        chamaChangeSituacao(row) {
            if(row.situacao==0){
                this.prompt(row);
            }else{
                this.serviceValoresKm
                    .verificarPossibilidadeDesativacao(row.id)
                    .then(r => {
                        if(r.content == null){
                            this.prompt(row);
                        }else if(r.content.acertoPadrao == 1){
                            this.$root.showMessage("alert", "acerto_padrao_vinculado");
                        }else{
                            this.prompt(row, 'valor_km_vinculado');
                        }
                    })
                    .catch(e => {
                        console.error(e);
                    });
            }
        },
        prompt(row, msg = null) {
            this.delete = row;
            let message = this.$t(msg != null
                ? msg
                : (row.situacao==1
                    ?"msg-confirmacao-desativacao-n"
                    :"msg-confirmacao-reativacao-n"), 
                { n: row.descricao }
            );

            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        buildIcon(icon) {
            return `<i class="fa-lg ${icon}"></i>`;
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.situacao == 1
                    ? "msg-erro-ao-desativar-tipo-veiculo"
                    : "msg-erro-ao-reativar-tipo-veiculo";
                    
            let tempSituacao = this.delete.situacao == 1 ? 0 : 1;

            let tipoveiculo = {
                idtipoveiculo: this.delete.id,
                situacao: tempSituacao
            }

            this.isLoading = true;

            this.service.updateSituacao(tipoveiculo)
                .then(r => {
                    if(r.status == 200){
                        if(r.content.situacao == 1){
                            this.$root.showMessage('success', 'msg-sucesso-ao-reativar-tipo-veiculo');
                        } else if (r.content.situacao == 0){
                            this.$root.showMessage('success', 'msg-sucesso-ao-desativar-tipo-veiculo');
                        }
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500){
                        this.$root.showMessage('error', 'Erro ao atualizar status do tipo veículo.');
                    }
        })
                .catch(e => {
                    console.error("Erro ao atualizar status do tipo veículo.", e);
                    this.$root.showMessage("error", tempFailure);
                })
                .finally(_ => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;

        .table-tag {
            width: 5rem !important;
        }

        .tipos-servicos .search-and-filter {
            display: flex;
            justify-content: space-between;
            margin: 10px 0;

            .search-bar {
                width: 80%;
                padding-right: 10px;
            }
            .situacao-select {
                width: 30%;
                div {
                    height: 40px;
                }
            }
            .filter-bar {
                width: 31%;
            }
            @media (max-width: 760px) {
                .search-bar {
                    padding-right: 0;
                }
                .situacao-select {
                    width: 100%;
                }
            }
        }
    }
}
</style>
